import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import BalancesPayouts from '../BalancesPayouts/BalancesPayouts';
import { apiService } from '../../services/api.service';
import { helperService } from '../../services/helper.service';
import { IClub, IUser } from '@eagerdog/interfaces';
import { Constants } from '@eagerdog/constants';
import './AdminBalances.scss';

interface IProps {}

const AdminBalances: React.FC<IProps> = () => {
  const { clubId } = useParams<{ clubId: string }>();
  const [currentClub, setCurrentClub] = useState<IClub | null>(null);
  const [, setLoading] = useState<boolean>(true);
  const user: IUser = helperService.getUser();

  useEffect(() => {
    const loadClub = async () => {
      if (!clubId) {
        setLoading(false);
        return;
      }

      try {
        if (user.user_type === Constants.user_type.club_manager) {
          // Club managers use the current club endpoint
          const club = await apiService.getCurrentClub();
          setCurrentClub(club);
        } else if (user.user_type === Constants.user_type.owner) {
          // Dog owners with admin capacity get club by ID
          const club = await apiService.getClub(clubId);
          setCurrentClub(club);
        }
      } catch (error) {
        console.error('Failed to load club:', error);
      } finally {
        setLoading(false);
      }
    };

    loadClub();
  }, [clubId, user.user_type]);





  return (
    <div className="AdminBalances">
      <header className="balancesHeader">
        <h1>Balances & Payouts</h1>
        <p className="subtitle">Manage your club's financial information and payout settings</p>
      </header>
      
      <div className="balancesContent">
        <BalancesPayouts hideHeader={true} clubId={clubId || currentClub?._id} />
      </div>
    </div>
  );
};

export default AdminBalances;
